<template>
  <main class="main" :class="{ 'expand-main': isMenuCollapse }">
    <h4 class="mb-3">Payment Methods</h4>
    <section>
      <div v-if="loading || loadingTotal">
        <LoadingSpinner />
      </div>
      <div v-else>
        <div class="row">
          <div class="col-12 card p-2 d-flex flex-row flex-wrap align-items-stretch">
              <div class="w-25 input-group input-group-sm p-3">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="pm-filter-name">Name</span>
                </div>
                <input type="text" class="form-control" v-model="filters.name" min="0" aria-labelledby="pm-filter-name" />
              </div>

              <div class="w-25 input-group input-group-sm p-3">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="pm-filter-type">Type</span>
                </div>
                <select class="form-control" v-model="filters.type" aria-labelledby="pm-filter-type">
                  <option value="">-</option>
                  <option value="sepa">SEPA</option>
                  <option value="credit_card">Credit Card</option>
                </select>
              </div>

              <div class="w-25 input-group input-group-sm p-3 position-relative treeselect-wrapper">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="pm-filter-client">{{ $t("lang.label.client") }}</span>
                </div>
                <treeselect
                  :disabled="loadingClients"
                  v-model="filters.client_id"
                  :options="clientsForTreeselect"
                  :normalizer="normalizeOptions"
                  :searchable="true"
                  :multiple="false"
                  :clearable="true"
                  :max-height="300"
                  v-bind:placeholder="$t('lang.label.search')"
                  @search-change="onClientSearchChange"
                  class="form-control inline-table"
                  aria-labelledby="pm-filter-client"
                />
              </div>
              <small
                v-if="loadingClients"
                class="spinner-border loading-spinner position-absolute"
                style="width: 15px; height: 15px; top: 50%; right: 12px; transform: translateY(-50%);"
              ></small>

              <div class="w-25 p-1 ml-auto">
                <div class="col-md-12 d-flex justify-content-end my-2">
                  <button class="btn btn-success" :disabled="loading" @click="loadRangeStats()">
                    <i class="icon-calendar-check-o mr-2"></i>
                    <small>
                      {{ $t("lang.label.letsgetstarted") }}
                    </small>
                  </button>
                </div>
              </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12 card p-2">
            <div class="bd-highlight">
              {{ $t("lang.label.results") }}:
              <small
                v-if="total == null || total == undefined"
                class="ml-1 text-primary"
                >{{ $t("lang.search.calculating") }}...</small
              >
              <strong v-else>{{ total }}</strong>
            </div>
            <div class="text-center">
              <Pagination
                :total="total"
                :totalpage="totalPage"
                :model="pagination"
                :limit="false"
                :color="'primary'"
                @changePage="changePage"
                key="paginationkey"
              ></Pagination>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-12 card">
            <div class="table-responsive mx-0 px-0">
              <Table
                v-if="methods.length > 0"
                class="mx-2 w-100"
                :headers="headers"
                :cols="cols"
                :data="methods"
                :checkbox="false"
                :notselect="true"
                :key="100"
                @editPaymentMethod="editPaymentMethod"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <Modal name="editPaymentMethod">
      <div v-if="loading">
        <LoadingSpinner></LoadingSpinner>
      </div>
      <form v-else @submit.prevent="onSubmit" class="p-4">
        <h4 class="text-center">SEPA Method</h4>
        <hr />
        <vue-form-generator
          ref="vfg"
          :schema="schema"
          :model="this.model"
          :options="formOptions"
        ></vue-form-generator>
        <hr />
        <div class="vue-form-generator">
          <div class="form-group valid field-submit col-sm-12">
            <div class="field-wrap float-right">
              <input id="" type="submit" value="Save" />
            </div>
          </div>
        </div>
      </form>
    </Modal>
  </main>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Pagination from "@/components/Common/Pagination.vue";
import Table from "@/components/Common/Table.vue";
import Modal from "@/components/Common/Modal.vue";
import VueFormGenerator from "vue-form-generator";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { billingsService, monitorService } from "@/_services";
import { mapState, mapActions } from "vuex";
export default {
  data() {
    var self = this;
    return {
      loading: false,
      loadingTotal: false,
      methods: [],
      pagination: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 100,
        currentPage: 1,
      },
      total: 0,
      filters: {
        name: "",
        type: "",
        client_id: 0
      },
      loadingClients: false,
      clients: [],
      clientSearchQuery: "",
      clientSearchTimer: null,
      selectedUser: {},
      schema: {
        fields: [
          {
            type: "input",
            inputType: "hidden",
            model: "id",
            readonly: true,
            featured: false,
            disabled: true,
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.nameonbankaccount"),
            model: "bank_account_name",
            readonly: false,
            required: true,
            disabled: false,
            min: 5,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.iban"),
            model: "iban",
            readonly: false,
            required: true,
            disabled: false,
            min: 15,
            max: 34,
            validator: (value, field, model) => {
              if (!value || value.length === 0) {
                return [this.$t("lang.label.required")];
              }
              if (value.includes(" ")) {
                return "Spaces are not allowed";
              }
              if (value.length < 15) {
                return "Minimum 15 characters required";
              }
              if (value.length > 34) {
                return "Maximum 34 characters allowed";
              }
              return [];
            },
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.swiftbic"),
            model: "swift_bic",
            readonly: false,
            required: true,
            disabled: false,
            min: 5,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.signatoryname"),
            model: "signatory_name",
            readonly: false,
            disabled: false,
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.addressline1"),
            model: "address_line_1",
            readonly: false,
            required: true,
            min: 5,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.addressline2"),
            model: "address_line_2",
            readonly: false,
            required: false,
            disabled: false,
            min: 5,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.postalcode"),
            model: "postal_code",
            readonly: false,
            required: true,
            min: 4,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.city"),
            model: "city",
            readonly: false,
            required: true,
            min: 4,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "switch",
            label: this.$t("lang.label.markasprincipal"),
            model: "default",
            textOn: this.$t("lang.label.principal"),
            textOff: this.$t("lang.label.no"),
            valueOn: "1",
            valueOff: "0",
            default: "1",
            disabled: true,
            styleClasses: "col-md-6",
          },
          {
            type: "select",
            label: "Registered SEPA direct debit",
            model: "sepa_direct_credit",
            featured: true,
            readonly: false,
            required: true,
            visible() {
              return self.user.role_id == 1;
            },
            values: [
              { id: 1, name: this.$t("lang.button.yes") },
              { id: 0, name: this.$t("lang.label.no") },
            ],
            styleClasses: "col-md-6",
          },
        ],
      },
      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: true,
      },
      headers: [
        {
          label: "Client Name",
          percentage: "0.1%",
          class: "overflowhide",
          id: 1,
        },
        {
          label: "Type",
          percentage: "0.1%",
          class: "overflowhide",
          id: 2,
        },
        {
          label: "Name",
          percentage: "0.1%",
          class: "overflowhide",
          id: 3,
        },
        {
          label: "ID",
          percentage: "0.1%",
          class: "overflowhide",
          id: 4,
        },
        {
          label: "Description",
          percentage: "0.1%",
          class: "overflowhide",
          id: 5,
        },
        {
          label: "Creation date",
          percentage: "0.1%",
          class: "overflowhide",
          id: 6,
        },
        {
          label: "Default",
          percentage: "0.1%",
          class: "overflowhide",
          id: 6,
        },
        {
          label: "Status",
          percentage: "0.1%",
          class: "overflowhide",
          id: 6,
        },
        {
          label: "Registered SEPA Direct Debit",
          percentage: "0.1%",
          class: "overflowhide",
          id: 6,
        },
        {
          label: "Actions",
          percentage: "0.1%",
          class: "overflowhide",
          id: 6,
        },
      ],
      cols: [
        [
          {
            value: "client_name",
            // value_label: "client_name",
            // value_emit: "client_id",
            // class: "text-primary",
            // type: "emit",
            // emit: "goToClient",
          },
        ],
        [
          {
            value: "type",
            type: "itemBadge",
            class: "badge badge-pill text-small",
            colors: [
              {
                id: "SEPA",
                label: "SEPA",
                bgColor: "blue",
                textColor: "#FFFFFF",
              },
              {
                id: "Credit Card",
                label: "Credit Card",
                bgColor: "green",
                textColor: "#FFFFFF",
              },
            ],
          },
        ],
        [
          {
            value: "name",
          },
        ],
        [
          {
            value: "id",
          },
        ],
        [
          {
            value: "description",
          },
        ],
        [
          {
            value: "creation_date",
          },
        ],
        [
          {
            value: "default_method",
          },
        ],
        [
          {
            value1: "deleted",
            value2: "valid",
            format: 2,
            type: "btnIfNotNull",
          },
        ],
        [
          {
            value: "sepa_direct_credit",
            type: "itemBadge",
            colors: [
              {
                id: 0,
                label: "NEW",
                bgColor: "#00c853",
                textColor: "#FFFFFF",
              },
            ],
          },
        ],
        [
          {
            type: "btnIfNotNull",
            format: 3,
            value_if: "type",
            value_equals: "SEPA",
            emit: "editPaymentMethod",
            value_emit: "id",
            class: "btn btn-sm btn-primary cursor-pointer",
            icon: "icon-pencil mr-1",
            label: "Modify Payment Method",
          },
        ],
      ],
    };
  },
  computed: {
    ...mapState({
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
    }),
    user() {
      return this.$store.state.authentication.user;
    },
    totalPage() {
      return this.methods.length;
    },
    model() {
      return this.selectedUser;
    },
    clientsForTreeselect() {
      var q = (this.clientSearchQuery || "").trim().toLowerCase();
      var out = [];

      // Si no escribió nada, muestra pocos (evita render masivo)
      if (!q) {
        out = this.clients.slice(0, 50);
      } else if (q.length < 2) {
        // Exige mínimo 2 chars para evitar filtrar en cada tecla
        out = [];
      } else {
        for (var i = 0; i < this.clients.length; i++) {
          var c = this.clients[i];
          if (c._search && c._search.indexOf(q) !== -1) {
            out.push(c);
            if (out.length >= 200) break;
          }
        }
      }

      // Que el cliente seleccionado siga apareciendo aunque no esté en el slice/filtro
      var selId = this.filters.client_id;
      if (selId != null && selId !== "") {
        var selected = this.clients.find(function (c) {
          return c.id == selId;
        });
        if (selected && !out.some(function (c) {
          return c.id == selId;
        })) {
          out = [selected].concat(out);
        }
      }
      return out;
    },
  },
  components: {
    LoadingSpinner,
    Table,
    Pagination,
    Modal,
    "vue-form-generator": VueFormGenerator.component,
    Treeselect,
  },
  created() {
    this.getData();
    this.getTotalData();
    this.getClients();
  },
  mounted() {
    this.setHeader();
  },
  methods: {
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild",
    }),
    setHeader() {
      this.setCurrentRoute({
        page: "payment_method",
        label: "Payment Methods",
      });
      this.setCurrentRouteChild({ child: "" });
    },
    normalizeOptions(node) {
      return {
        id: node.id,
        label: node.label
      };
    },
    getClients() {
      var self = this;
      this.loadingClients = true;
      const toCreateUser = 1;
      monitorService
        .getClients(null, "2,3,4,5,9", toCreateUser)
        .then(function (res) {
          var list = Array.isArray(res) ? res : (res && res.data ? res.data : []);
          self.clients = list.map(function (client) {
            var label = client.name || client.label || "";
            return {
              id: client.id,
              label: label,
              _search: String(label).toLowerCase(),
            };
          });
          if (
            self.filters.client_id != null &&
            !self.clients.some(function (c) {
              return c.id == self.filters.client_id;
            })
          ) {
            self.filters.client_id = null;
          }
        })
        .catch(function (err) {
          console.log(err);
        })
        .then(function () {
          self.loadingClients = false;
        });
    },
    onClientSearchChange(query) {
      var self = this;
      if (this.clientSearchTimer) clearTimeout(this.clientSearchTimer);
      this.clientSearchTimer = setTimeout(function () {
        self.clientSearchQuery = query || "";
      }, 200);
    },
    loadRangeStats() {
      this.pagination.cantPerPage = 25;
      this.pagination.currentPage = 1;
      this.getData();
      this.getTotalData();
    },
    openModal(name) {
      this.$modal.show(name);
    },
    closeModal(name) {
      this.$modal.hide(name);
    },
    editPaymentMethod(id) {
      console.log(id);
      this.getPaymentMethodSepaById(id);
      this.openModal("editPaymentMethod");
    },
    changePage() {
      this.getData();
    },
    onSubmit() {
      this.closeModal("editPaymentMethod");
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousure"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          billingsService.saveSepaPaymentMethod(this.model).then((response) => {
            this.$swal({
              type: "success",
              title: this.$t("lang.label.great"),
              text: this.$t("lang.label.paymentmethodaddedsuccesfully"),
              showConfirmButton: false,
              timer: 7000,
            });
            window.location.reload();
          })
          .catch((error) => {
            this.$swal({
              type: "error",
              title: this.$t("lang.label.error"),
              html: this.$t("lang.general.error"),
              showConfirmButton: false,
              timer: 7000,
            });
          })
          .finally(() => {
            this.loading = false
          })
        }
      });
    },
    getPaymentMethodSepaById(id) {
      this.loading = true;
      billingsService
        .getPaymentMethod(id, "sepa")
        .then((response) => {
          this.selectedUser = response;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getData() {
      this.filters.client_id = this.filters.client_id == undefined || this.filters.client_id == null ? 0 : this.filters.client_id;
      const filters = {
        ...this.filters,
        cantPerPage: this.pagination.cantPerPage,
        currentPage: this.pagination.currentPage,
        total: 0,
      };
      this.loading = true;
      billingsService
        .getAllClientPaymentMethods(filters)
        .then((response) => {
          this.methods = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getTotalData() {
      const filters = {
        ...this.filters,
        cantPerPage: this.pagination.cantPerPage,
        currentPage: this.pagination.currentPage,
        total: 1,
      };
      this.loadingTotal = true;
      billingsService
        .getAllClientPaymentMethods(filters)
        .then((response) => {
          this.total = response.total;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingTotal = false;
        });
    },
  },
};
</script>

<style></style>
